import type { AssetTypeTemplateSaveBarWrapperProps } from "./asset-type-template-save-bar.type";

import { AssetTypeTemplateSaveBar } from "./asset-type-template-save-bar.component";
import "./asset-type-template-save-bar.style.less";

export const AssetTypeTemplateSaveBarWrapper = ({
  ...componentProps
}: AssetTypeTemplateSaveBarWrapperProps) => {
  return (
    <div className="asset-type-template-save-bar">
      <AssetTypeTemplateSaveBar {...componentProps} />
    </div>
  );
};
